export function formatCategoryPathForDisplay(path: string): string {
  return path.replace(/\//g, " > ")
}

export function getUniqueCategoryPathsWithPrefixes(existingPaths: string[]): string[] {
  const paths = new Set<string>()
  for (const path of existingPaths) {
    const parts = path.split("/").filter(Boolean)
    for (let i = 1; i <= parts.length; i++) {
      paths.add(parts.slice(0, i).join("/"))
    }
  }
  return Array.from(paths).sort()
}
